import { render, staticRenderFns } from "./top-setting.vue?vue&type=template&id=12b0268e&scoped=true&"
import script from "./top-setting.vue?vue&type=script&lang=js&"
export * from "./top-setting.vue?vue&type=script&lang=js&"
import style0 from "./top-setting.vue?vue&type=style&index=0&id=12b0268e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0268e",
  null
  
)

export default component.exports